<template>
  <div
    :class="[
      'grid grid-rows-[auto_1fr] h-full text-white pay-container bg-gradient-to-r font-[Cubic]',
      active === 0 && 'to-[#642B73] from-base-100',
      active === 1 && 'to-[rgb(232,66,94)] from-[rgb(206,52,76)]',
      active === 2 && 'to-[#00c6fb] from-[#005bea]',
    ]"
  >
    <ThreadsNav :show-center="false" class="bg-transparent" show-back>
      <template #right>
        <CrystalPowerCount />
      </template>
    </ThreadsNav>
    <div
      class="flex gap-2 items-start overflow-hidden flex-col sm:flex-row p-2 sm:p-4"
    >
      <div
        class="flex sm:flex-col gap-2 justify-between w-full sm:w-fit items-center"
      >
        <div
          class="flex sm:flex-col gap-4 text-lg p-2 w-fit glass rounded-full overflow-hidden"
        >
          <button
            :class="{ 'glass overflow-hidden': active === 1 }"
            class="btn btn-ghost btn-circle btn-xs sm:btn-sm"
            @click="active = 1"
          >
            <crystal-icon class="icon-2xl" />
          </button>
          <button
            :class="{ 'glass overflow-hidden': active === 2 }"
            class="btn btn-ghost btn-circle btn-xs sm:btn-sm"
            @click="active = 2"
          >
            <power-icon class="icon-lg ml-0.5" />
          </button>
          <button
            :class="{ 'glass overflow-hidden': active === 3 }"
            class="btn btn-ghost btn-circle btn-xs sm:btn-sm"
            @click="active = 3"
          >
            <EnergyBoxIcon />
          </button>
        </div>
        <div class="flex gap-2">
          <button
            class="btn btn-xs btn-ghost text-white/80 font-sans whitespace-nowrap"
            @click="contactCustomerService"
          >
            {{ $t("Message.contactCustomerService") }}
          </button>

          <button
            class="btn btn-xs btn-ghost text-white/80 font-sans whitespace-nowrap"
            @click="router.push({ name: 'powerCube' })"
          >
            {{ $t("setting.billing") }}
          </button>
        </div>
      </div>
      <div class="overflow-y-auto relative h-full flex flex-col gap-2">
        <div
          v-if="active === 1"
          class="rounded-xl overflow-y-auto relative flex flex-col shadow-[0_-5px_15px_-5px_#333] flex-1 cross-pattern"
        >
          <div
            class="relative rounded-lg overflow-hidden drop-shadow h-16 w-full"
          >
            <div
              class="absolute top-0 bottom-0 left-0 right-0 p-4 darken-linear-background-b flex flex-col justify-end gap-2"
            >
              <h1
                class="text-xl sm:text-2xl font-semibold flex gap-2 items-end"
              >
                <crystal-icon class="icon-2xl" />
                {{ $t(`purchase.crystal.buy`) }}
              </h1>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-2.5 p-3 sm:p-4">
            <div
              v-for="(item, idx) in purchaseList"
              :key="idx"
              class="btn btn-error bg-[#e52d27] h-[auto] p-0 border-0 text-white overflow-hidden drop-lg glass rounded-lg"
              @click="
                userStore.clickPayItem(
                  {
                    id: item.id,
                    quantity: item.quantity,
                    buildNumber: Number(packageInfo?.buildNumber ?? 0),
                  },
                  idx
                )
              "
            >
              <div class="flex flex-col justify-end text-left w-full h-full">
                <div class="grid grid-cols-2 px-4 py-2">
                  <div class="flex flex-col justify-center">
                    <p class="text-lg md:text-2xl font-bold relative z-10">
                      {{ item.quantity }}
                    </p>
                    <p class="relative z-10">
                      {{ $t(`purchase.crystal.name`) }}
                    </p>
                  </div>
                  <img
                    :src="crystalArr[idx]"
                    alt=""
                    class="flex-1 w-full max-w-[8rem]"
                  />
                </div>
                <p
                  class="text-xs text-white/80 flex gap-1 z-10 p-2 items-center justify-end"
                >
                  {{
                    $t(`purchase.crystal.exchange`, {
                      amount: item.quantity * 10,
                    })
                  }}
                  <PowerIcon class="icon-xs opacity-80" />
                </p>
                <div
                  class="bg-[rgba(206,52,76,0.8)] flex items-center px-3 justify-between font-mono p-2 w-full h-10"
                >
                  <p class="font-bold">¥{{ item.price }}</p>
                  <p
                    v-if="
                      idx !== 0 &&
                      computedRate(item.quantity, item.price) !== '-0' &&
                      computedRate(item.quantity, item.price) !== '0'
                    "
                    class="text-xs text-right relative z-10 font-bold"
                  >
                    {{ $t(`purchase.sub.save`) }}
                    {{ computedRate(item.quantity, item.price) }}%
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="active === 2">
          <div
            class="rounded-xl relative flex flex-col shadow-[0_-5px_15px_-5px_#333] cross-pattern"
          >
            <div
              class="relative rounded-lg overflow-hidden drop-shadow h-16 w-full"
            >
              <div
                class="absolute top-0 bottom-0 left-0 right-0 p-4 darken-linear-background-b flex justify-between items-center gap-2"
              >
                <h1
                  class="text-xl sm:text-2xl font-semibold flex gap-2 items-center"
                >
                  <power-icon class="icon-2xl" />
                  {{ $t(`purchase.power.buy`) }}
                </h1>

                <button
                  class="btn btn-xs btn-primary"
                  @click="router.push({ name: 'member' })"
                >
                  开通会员，低至七折
                </button>
              </div>
            </div>
            <ul class="grid grid-cols-2 gap-2.5 p-3 sm:p-4">
              <li
                v-for="(item, idx) in powerCount"
                :key="idx"
                class="btn btn-info bg-[#005bea] h-[auto] p-0 border-0 text-white overflow-hidden drop-lg glass rounded-lg"
                @click="clickPower(item)"
              >
                <div class="flex flex-col justify-end text-left w-full h-full">
                  <div class="grid grid-cols-2 px-4 py-2">
                    <div class="flex flex-col justify-center">
                      <p class="text-lg md:text-2xl font-bold relative z-10">
                        {{ item * CUBE_NUM_PER_TICKET }}
                      </p>
                      <p class="relative z-10">
                        {{ $t(`purchase.power.name`) }}
                      </p>
                    </div>
                    <div class="flex-1 items-center justify-center flex">
                      <img
                        :class="[
                          'max-w-[6rem]',
                          idx === 0 ? 'w-[60%] max-w-[4.9rem]' : 'w-[80%]',
                        ]"
                        :src="powerArr[idx]"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="bg-[rgba(0,91,234,0.8)] flex items-center px-3 justify-between font-mono p-2 w-full h-10"
                  >
                    <img :src="useCrystalUrl()" alt="" class="w-[34px] mr-1" />
                    <p class="font-bold text-base">{{ item }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            class="rounded-xl relative flex flex-col shadow-[0_-5px_15px_-5px_#333] cross-pattern"
          >
            <div
              class="relative rounded-lg overflow-hidden drop-shadow h-16 w-full"
            >
              <div
                class="absolute top-0 bottom-0 left-0 right-0 p-4 darken-linear-background-b flex flex-col justify-end gap-2"
              >
                <div class="flex justify-between items-center">
                  <h1
                    class="text-xl sm:text-2xl font-semibold flex gap-2 items-center"
                  >
                    <power-icon class="icon-2xl" />
                    {{ $t(`purchase.power.getPower`) }}
                  </h1>
                </div>
              </div>
            </div>
            <ul class="flex flex-col p-4">
              <li v-if="enableTaskSection">
                <div class="flex items-center gap-2 justify-between">
                  <div class="flex items-center gap-0.5">
                    <div>{{ $t(`purchase.power.watchVideo`) }} +2</div>
                    <PowerIcon class="icon-base relative -top-0.5" />
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="text-white/80">
                      {{ userStore.user.adPowerAmountDailyCurrent ?? 0 }} /
                      {{ userStore.user.adPowerAmountDailyMax ?? 5 }}
                    </div>
                    <button
                      v-if="
                        userStore.user.adPowerAmountDailyCurrent <
                        userStore.user.adPowerAmountDailyMax
                      "
                      @click="onRewardVideoClick"
                      class="btn btn-sm rounded border text-white border-white bg-transparent"
                    >
                      {{ $t(`purchase.power.goToComplete`) }}
                    </button>
                    <div v-else class="text-success flex items-center">
                      <i class="iconify mingcute--check-circle-fill" />
                    </div>
                  </div>
                </div>
              </li>
              <li
                v-if="enableTaskSection"
                class="divider before:bg-white/10 after:bg-white/10"
              />
              <li>
                <div class="w-full">
                  <img
                    src="/img/share-banner.png"
                    alt=""
                    class="w-full"
                    @click="router.push({ name: 'shareXhs' })"
                  />
                </div>
              </li>
            </ul>
          </div>
        </template>

        <template v-if="active === 3">
          <div
            class="rounded-xl relative flex flex-col shadow-[0_-5px_15px_-5px_#333] cross-pattern"
          >
            <div
              class="relative rounded-lg overflow-hidden drop-shadow h-16 w-full"
            >
              <div
                class="absolute top-0 bottom-0 left-0 right-0 p-4 darken-linear-background-b flex flex-col justify-end gap-2"
              >
                <h1
                  class="text-xl sm:text-2xl font-semibold flex gap-2 items-center"
                >
                  <EnergyBoxIcon />
                  兑换能量箱
                </h1>
              </div>
            </div>
            <ul class="grid grid-cols-2 gap-2.5 p-3 sm:p-4">
              <li
                v-for="(item, idx) in energyBoxList"
                :key="idx"
                class="btn btn-info h-[auto] p-0 border-0 text-white overflow-hidden drop-lg glass rounded-lg"
                @click="clickEnergyBox(item)"
              >
                <div class="flex flex-col justify-end text-left w-full h-full">
                  <div class="grid grid-cols-2 px-4 py-2">
                    <div class="flex flex-col justify-center">
                      <p class="text-lg md:text-2xl font-bold relative z-10">
                        能量箱
                      </p>
                      <p :class="['relative z-10']">
                        {{ $t(`mission.equipment.rarity.${item}`) }}
                      </p>
                    </div>
                    <div class="flex-1 items-center justify-center flex">
                      <img
                        class="w-[120px] img-render-nearest"
                        :src="`/img/energy-box-${item}.png`"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="bg-base-100/30 flex items-center px-3 justify-between font-mono p-2 w-full h-10"
                  >
                    <PowerIcon class="icon-xl" />
                    <p class="font-bold text-base">
                      {{ energyBoxPowerCount[idx] }}
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </template>
      </div>
    </div>
    <PaymentPopup />
    <van-dialog
      v-model:show="showRewardVideoDialog"
      :title="$t(`purchase.power.finishedRewardVideoTask`)"
    >
      <div
        class="flex flex-col gap-2 text-base-content justify-center items-center p-4"
      >
        <p class="flex items-center gap-1">
          {{ $t(`purchase.power.rewardVideoTaskDesc`) }}
          <PowerIcon class="icon-base relative -top-0.5" />
        </p>
      </div>
    </van-dialog>

    <EquipmentDetailModal
      v-model:show="showEquipmentModal"
      :equipment="activeEquipment"
      mode="edit"
      show-gain-title
    />
  </div>
</template>

<script lang="ts" setup>
import {
  ApiGetCrystalPackage,
  ApiPostCrystalTransactionBuyPower,
  ApiPostUserPurchaseChest,
} from "@/apis/crystal";
import PaymentPopup from "@/components/mobile/common/PaymentPopup.vue";
import {
  copyToClipboard,
  isAndroidWebview,
  isIOSWebview,
} from "@/modules/common";
import { CUBE_NUM_PER_TICKET } from "@/modules/constant";
import { useGlobalModal } from "@/stores/globalModal";
import { useGlobalUser } from "@/stores/globalUser";
import { StorageGet, StorageSet } from "@/tools/localStorage";
import { MateEquipment } from "@/types/entity";
import { useAppVersion, useCrystalUrl, usePowerUrl } from "@/use/common";
import { useRouteQuery } from "@vueuse/router";
import {
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const taskType = useRouteQuery<string>("task", "");
const status = useRouteQuery<number | null>("status", null, {
  transform: (value) => (value ? Number(value) : null),
});
const userStore = useGlobalUser();
const modalStore = useGlobalModal();
const { t } = useI18n();
const active = ref(1);
const showRewardVideoDialog = ref(false);
const crystalArr = [
  useCrystalUrl(),
  `/img/pay/crystal2.png`,
  `/img/pay/crystal3.png`,
  `/img/pay/crystal4.png`,
];

const purchaseList = ref<any[]>([]);

// power cube
const powerCount = [5, 15, 45, 1000];
const powerArr = [
  usePowerUrl(),
  `/img/pay/power2.png`,
  `/img/pay/power3.png`,
  `/img/pay/power4.png`,
];

const energyBoxPowerCount = [4, 18, 300];
const energyBoxList = [1, 2, 3];

const packageInfo = useAppVersion();

const clickPower = async (crystal: number) => {
  try {
    if (userStore.user.crystalQuantity < crystal) {
      await userStore.updateCurrentMateId();
      if (userStore.user.crystalQuantity < crystal) {
        showFailToast(t("Message.notEnoughCrystal"));
        active.value = 1;
        return;
      }
    }
    await showConfirmDialog({
      title: t("purchase.swap.powerConfirm", {
        crystal,
        power: crystal * CUBE_NUM_PER_TICKET,
      }),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });
    const loading = showLoadingToast(t("Message.swapping"));
    try {
      await ApiPostCrystalTransactionBuyPower(crystal);

      modalStore.openReceivedModal(
        [
          {
            type: "powerCube",
            amount: crystal * CUBE_NUM_PER_TICKET,
          },
        ],
        "CrystalOrderPay"
      );
    } catch (e) {
      console.log(e);
    }
    loading.close();
  } catch (e) {
    console.log(e);
  }
};

const computedRate = (amount: number, money: number) => {
  const rate = 5 / 4.99;
  const _amount = money * rate;
  return (((amount - _amount) / amount) * 100).toFixed(0);
};

const contactCustomerService = async () => {
  try {
    await showConfirmDialog({
      title: t("Message.contactCustomerService"),
      message: "请加入qq群795055136咨询工作人员",
      confirmButtonText: "复制群号",
      cancelButtonText: t("Buttons.cancel"),
    });
    copyToClipboard("795055136");
    showSuccessToast({
      message: t("Message.copySuccessful"),
      duration: 500,
    });
  } catch (e) {
    console.log(e);
  }
};

watch([taskType, status], async () => {
  if (!(taskType.value && status.value !== null)) return;
  if (taskType.value === "rewardVideo" && status.value === 0) {
    router.replace({ query: {} });
  } else if (taskType.value === "rewardVideo" && status.value === 1) {
    showRewardVideoDialog.value = true;
    await userStore.refreshUser();
    router.replace({ query: {} });
  }
});

const enableTaskSection = computed(() => {
  if (isAndroidWebview && Number(packageInfo?.buildNumber ?? 0) >= 23) {
    return true;
  } else if (isIOSWebview && Number(packageInfo?.buildNumber ?? 0) >= 26) {
    return true;
  }
  return false;
});

const onRewardVideoClick = () => {
  if (taskType.value === "rewardVideo") return;
  if (
    userStore.user.adPowerAmountDailyCurrent >=
    userStore.user.adPowerAmountDailyMax
  ) {
    return;
  }

  // 1. 校验是否可以看视频
  // 2. 如果可以看视频，跳转路由增加query
  router.replace({
    query: {
      task: "rewardVideo",
    },
  });
};

const showEquipmentModal = ref(false);
const activeEquipment = ref<MateEquipment | undefined>(undefined);

const clickEnergyBox = async (item: number) => {
  try {
    const powerCount = energyBoxPowerCount[item - 1];

    if (
      modalStore.shouldOpenPowerNotEnoughModal({
        spentPowerAmount: powerCount,
        cb: () => clickEnergyBox(item),
      })
    ) {
      return;
    }

    await showConfirmDialog({
      title: t("purchase.swap.energyBoxConfirm", {
        power: powerCount,
        rarity: t(`mission.equipment.rarity.${item}`),
      }),
      confirmButtonText: t("Buttons.confirm"),
      cancelButtonText: t("Buttons.cancel"),
    });
    const loading = showLoadingToast(t("Message.swapping"));
    try {
      const { item: data } = await ApiPostUserPurchaseChest(item);
      activeEquipment.value = data;
      showEquipmentModal.value = true;
      userStore.refresh();
    } catch (e) {
      console.log(e);
    }
    loading.close();
  } catch (e) {
    console.log(e);
  }
};

onMounted(async () => {
  if (isAndroidWebview) {
    console.log("packageInfo:", JSON.stringify(packageInfo));
  }
  purchaseList.value = StorageGet("purchaseList") || [];
  active.value = (route.hash && Number(route.hash.slice(1))) || 1;
  let loading;
  if (!purchaseList.value.length)
    loading = showLoadingToast(t("Message.loading"));
  const { itemzz } = await ApiGetCrystalPackage();
  purchaseList.value = itemzz;
  StorageSet("purchaseList", itemzz);
  if (loading) loading.close();
  await userStore.refreshUser();
});
</script>
<style scoped>
.power-btn {
  background-image: linear-gradient(to right, #e52d27 0%, #b31217 100%);
}

.cross-pattern {
  background-color: hsl(212 18% 14%);
  opacity: 0.8;
  background: radial-gradient(
      circle,
      transparent 20%,
      hsl(212 18% 14%) 20%,
      hsl(212 18% 14%) 80%,
      transparent 80%,
      transparent
    ),
    radial-gradient(
        circle,
        transparent 20%,
        hsl(212 18% 14%) 20%,
        hsl(212 18% 14%) 80%,
        transparent 80%,
        transparent
      )
      25px 25px,
    linear-gradient(hsl(213 18% 20%) 2px, transparent 2px) 0 -1px,
    linear-gradient(90deg, hsl(213 18% 20%) 2px, hsl(212 18% 14%)) 2px -1px;
  background-size: 50px 50px, 50px 50px, 25px 25px, 25px 25px;
}

.cross-pattern-red {
  background-color: rgba(100, 0, 0, 0.09);
}

.pay-container {
  transition: background-color 0.5s;
}

:deep(.cross-pattern-red .van-tabs__nav) {
  background-color: transparent !important;
}
</style>
